import { AccessorsMutatorsDecorator, Model } from "../../helpers";

/**
 * @class ShomoosApiLog
 *
 * @property {number} id
 */
export class ShomoosApiLog extends Model {}

AccessorsMutatorsDecorator(
  "id",
  "property_id",
  "transaction_id",
  "is_success",
  "api_type",
  "requested_at",
  "request_body",
  "responded_at",
  "response_body",
  "reservation_ident"
)(ShomoosApiLog);



// WEBPACK FOOTER //
// ./src/pms-api/models/shomoos-api-log.model.js